// List view — compact table, mobile-safe (stacks on small screens).
import { Sparkles } from "lucide-react";
import { STAGE_LABELS } from "./SalesCRM";

export default function ListView({ data, onOpen }) {
    const cards = data.cards || [];
    if (!cards.length) return <div className="text-sm text-neutral-500 py-8 text-center" data-testid="list-empty">No leads match these filters.</div>;
    return (
        <div className="bg-white rounded-xl border border-neutral-200 divide-y" data-testid="list-view">
            <div className="hidden md:grid grid-cols-[2fr,1fr,1fr,1fr,1.5fr,1fr] gap-2 px-4 py-2 text-[10px] uppercase tracking-[0.12em] text-neutral-500">
                <span>Brand</span><span>Stage</span><span>Priority</span><span>Value</span><span>Next action</span><span>Follow-up</span>
            </div>
            {cards.map((c) => (
                <div key={c.id} data-testid={`list-row-${c.id}`} className="grid grid-cols-2 md:grid-cols-[2fr,1fr,1fr,1fr,1.5fr,1fr] gap-2 px-4 py-2.5 text-xs hover:bg-neutral-50 items-center">
                    <button onClick={() => onOpen(c.id)} className="text-left font-medium text-cafe-espresso hover:underline">{c.brand}
                        <span className="block text-[10px] text-neutral-400 font-normal">{[c.business_type, c.location].filter(Boolean).join(" · ")}</span>
                    </button>
                    <span>{STAGE_LABELS[c.stage] || c.stage}</span>
                    <span className="capitalize">{c.priority}</span>
                    <span>{c.value > 0 ? `RM ${Math.round(c.value).toLocaleString()}${c.value_is_estimate ? " (est.)" : ""}` : "—"}</span>
                    <span className="text-cafe-olive">{c.next_action || "—"}</span>
                    <span className="flex items-center justify-between gap-1">
                        <span className={c.followup_status === "overdue" ? "text-red-600 font-semibold" : c.followup_status === "due_today" ? "text-cafe-terracotta" : "text-neutral-500"}>
                            {c.followup_status === "overdue" ? `⚠ ${c.followup_date}` : c.followup_date || "—"}
                        </span>
                        <button data-testid={`list-brain-${c.id}`} title="Analyse with AI Sales Brain" onClick={() => onOpen(`${c.id}#brain`)}
                            className="p-1 rounded-full border border-cafe-espresso/30 text-cafe-espresso hover:bg-cafe-espresso hover:text-white"><Sparkles size={11} /></button>
                    </span>
                </div>
            ))}
        </div>
    );
}
